import service from "../../services/etiquetas/tags";

export default {
  namespaced: true,
  state: {
    service: new service(),
    tags: [],
    tagsEmp: [],
    newTag: {},
    editTag: {},
    mode: "",
    modeForm: "",
    openform: false,
    openDelete: false,
    deleteItem: [],
  },

  mutations: {
    setTags(state, data) {
      state.tags = data;
    },
    setTagsEmp(state, data) {
      state.tagsEmp = data;
    },
    setNewTag(state, data) {
      state.newTag = data;
    },
    setEditTag(state, data) {
      state.editTag = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setOpenform(state, data) {
      state.openform = data;
    },
    setModeForm(state, data) {
      state.modeForm = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
  },
  actions: {
    async getTags({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getTags();
          commit("setTags", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", false, { root: true });
        }
      });
    },

    async addTag({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.addTag(state.newTag).then((data) => {
            let options = state.tags;
            options.push(data);

            commit("setTags", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async addTagsGroup({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.addTagsGroup(state.newTag).then((data) => {
            dispatch("getTags");
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async deleteTags({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.deleteTags(state.deleteItem.id).then(() => {
            let options = state.tags;
            options = options.filter((option) => {
              return option.id != state.deleteItem.id;
            });
            commit("setTags", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async editTag({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.editTag(state.editTag).then(async () => {
            let item = await state.service.getTags();

            commit("setTags", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async addTagsEmpGroup({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.service.addTagsEmpGroup(state.newTag).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    /*     async getEmpTags(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getEmpTags(state.state.tagId);
          state.commit("setTagsEmp", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    }, */

    async getOneEmpTags({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getOneEmpTags();
          commit("setTagsEmp", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async deleteEmpTag({ state, dispatch, commit }, idTag) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.deleteEmpTag(idTag).then(async () => {
            let item = await state.service.getOneEmpTags();
            commit("setTagsEmp", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
